export default __webpack_public_path__ + "static/media/noa-3.bc5bab64.jpg";